<div class="announcement" *ngIf="showAnnouncement && loggedIn">
  <fa-icon [icon]="announcementIcon"></fa-icon>
  We want to hear from you - take the
  <a href="https://learn.wordflight.com/2025-26-eoy-survey" target="_blank">WordFlight Experience Survey</a>
</div>
<wf-header></wf-header>
<wf-loading-mask></wf-loading-mask>
<div class="content-wrapper" [ngClass]="{ 'dark-background' : districtsBackground }" [ngStyle]="{'max-height' : (showAnnouncement && loggedIn) ? 'calc(100vh - 112px)' : 'calc(100vh - 80px)'}">
  <wf-sidebar class="sidebar-content" [ngClass]="{ 'hidden' : (!loggedIn || !shouldShowSidebar) }"></wf-sidebar>
  <div class="main-content" [ngClass]="{ 'sidebar-revert' : !shouldShowSidebar }">
    <router-outlet></router-outlet>
  </div>
</div>
